import { OnInit, Component, ViewEncapsulation } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { ValidatorService } from 'app/shared/services/validator.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppConfig } from 'app/app.config';
import { ISelect } from 'app/shared/models/select.model';
import { RecruitmentService } from 'app/views/appviews/recruitment/recruitment.service';
import { EmployeeService } from 'app/views/appviews/employee.service';
import { IDtoEmployeeShippingAddress } from 'app/shared/models/employee/dto-employee-shipping-address.model';
import { IDtoJobCandidateBasic } from 'app/shared/models/employee/dto-jobcandidate-basic.model';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'app-modal-basic-data',
    styleUrls: ['./modal-basic-data.style.scss'],
    templateUrl: './modal-basic-data.template.html',
    encapsulation: ViewEncapsulation.None
})

export class ModalBasicDataComponet implements OnInit {
    /**Validadores */
    private validator = ValidatorService;
    private fsaFlags = [false];
    private errorMessages: any;
    /**Formularios */
    private formBasicData: FormGroup;
    private uKey: string;
    /** Catalogos */
    private catalogTowns: ISelect[];
    private catalogStates: ISelect[];
    private address: IDtoEmployeeShippingAddress;
    private employee: IDtoJobCandidateBasic;
    constructor(private bsModalRef: BsModalRef
        , private formBuilder: FormBuilder
        , private configGeneral: AppConfig
        , private recruitmentService: RecruitmentService
        , private employeeService: EmployeeService
        , private spinner: NgxSpinnerService) {
        this.initializeForm();
        this.getCatalogStates();
    }
    ngOnInit(): void {
        this.getEmployeeShippingAddress(this.uKey);
    }
    private getCatalogStates(): void {
        this.recruitmentService.getCatalogStates().subscribe((res) => {
            this.catalogStates = res;
        });
    }
    private getCatalogTowns(id: string): void {
        this.recruitmentService.getCatalogTowns(id).subscribe((res) => {
            this.formBasicData.get('townId').setValue(null);
            this.catalogTowns = res;
            this.formBasicData.get('townId').setValue(this.address.townId.toString());
        });
    }
    private initializeForm() {
        this.formBasicData = this.formBuilder.group({
            street: [null, [Validators.required, Validators.maxLength(100)]],
            interiorNumber: [null, [Validators.maxLength(10)]],
            externalNumber: [null, [Validators.required, Validators.maxLength(10)]],
            suburb: [null, [Validators.required, Validators.maxLength(50)]],
            townId: [null, [Validators.required]],
            state: [null, [Validators.required]],
            postalCode: [null, [Validators.required, Validators.maxLength(6), Validators.minLength(5)]],
            reference: [null, [Validators.maxLength(300)]],
            email: [null, [Validators.required, Validators.email, Validators.maxLength(100)]],
            personalNumber: [null, [Validators.required, Validators.minLength(10), Validators.maxLength(10)]]
        });
    }
    private submit(): void {
        if (this.formBasicData.valid) {
            let dto = this.formBasicData.value as IDtoEmployeeShippingAddress;
            dto.jobCandidateId = this.address.jobCandidateId;
            dto.stateId = Number(dto.state);
            this.updateEmployeeShippingAddress(dto);
            this.updateEmployeeEmailAndPersonalNumber(dto);
        } else {
            this.configGeneral.newToast('Validación', 'Capture toda la información requerida para poder continuar', 'warning');
            this.configGeneral.touchedControls(this.formBasicData);
        }
    }
    private getEmployeeShippingAddress(uKey: string): void {
        this.employeeService.getEmployeeShippingAddressByUKey(uKey).subscribe((res) => {
            if (res == null) {
                this.configGeneral.newToast('Error', 'No existe una dirección de envío valida', 'error');
            } else {
                this.address = res;
                this.address.state = this.address.stateId.toString();
                this.formBasicData.patchValue(res);
                this.getCatalogTowns(this.address.stateId.toString());
            }
            this.formBasicData.get('email').setValue(this.employee.email);
            this.formBasicData.get('personalNumber').setValue(this.employee.personalNumber);
        });
    }
    private updateEmployeeShippingAddress(dto: IDtoEmployeeShippingAddress): void {
        this.spinner.show();
        this.employeeService.updateEmployeeShippingAddress(dto)
          .subscribe(
            (x) => {
                this.configGeneral.notificationSuccessError(x)
                this.spinner.hide();
            },
            (errMessage) => {
              this.spinner.hide();
              this.configGeneral.newToast('Error', errMessage.message, 'error');
          });
      }
      private updateEmployeeEmailAndPersonalNumber(dto: IDtoEmployeeShippingAddress): void {
        this.spinner.show();
        let ent = {} as IDtoJobCandidateBasic;
        ent.id = this.employee.id;
        ent.personalNumber = dto.personalNumber;
        ent.email = dto.email;
        this.employeeService.updateEmployeeEmailAndPersonalNumber(ent)
          .subscribe(
            (x) => {
                if(this.configGeneral.notificationSuccessError(x)) {
                    this.employee.personalNumber = ent.personalNumber;
                    this.employee.email = ent.email;
                }
                this.spinner.hide();
            },
            (errMessage) => {
              this.spinner.hide();
              this.configGeneral.newToast('Error', errMessage.message, 'error');
          });
      }
    private onCancel(): void {
        this.bsModalRef.hide();
    }
}
